// The two cookies of the visitor's look switcher on a breeder Site (full
// phase 097, `doc/site-layout.md` 5.4.3), under the names
// `Kotofon::SiteLook::PALETTE_COOKIE` and `THEME_COOKIE` read on the server.
// A cookie holds a choice that differs from the Site's own look; choosing the
// Site's own palette or its default theme deletes it, so a visitor back on
// the defaults sends nothing.
export const PALETTE_COOKIE = "kotofon_look_palette"
export const THEME_COOKIE = "kotofon_look_theme"
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 30

// The theme cookie's value for `choice`: empty, which deletes it, for the
// Site's default theme.
export function themeCookieValue(choice: string, defaultTheme: string): string {
  return choice === defaultTheme ? "" : choice
}

// The `document.cookie` assignment for `name`: an empty value expires it at
// once. `Secure` on https only: the development host and a browser spec serve
// plain http, where a secure cookie is dropped.
export function lookCookie(name: string, value: string, protocol: string): string {
  const secure = protocol === "https:" ? "; Secure" : ""
  const age = value === "" ? 0 : COOKIE_MAX_AGE
  return `${name}=${encodeURIComponent(value)}; max-age=${age}; path=/; SameSite=Lax${secure}`
}
